module.exports = __webpack_public_path__ + "img/delete.8b70d8d8.svg";